import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE, VIEW, EDIT } from "const"
import {
    MarkovModel,
    MarkovModelCreate,
} from "server/models"
import {
    useInput,
    StateType,
    replaceHistoryState,
    forceRerenderContent,
} from "client/utils"
import { markovModelsRoute } from "client/parts/routes"
import {
    StoreType,
    MarkovModelValidation,

    SaveMarkovModel,

    setMarkovModelEdit,
    setMarkovModelReloadList,
    setMarkovModelReloadView,
    setMarkovModelReloadEdit,
    closeModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

interface EditModelProps {
    model: MarkovModel
}

let isMounted: boolean

const Form = ({
    model,
}: EditModelProps) => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(model.name)
    const [description, setDescription] = useInput(model.description)

    const [validation, setValidation] = useState<MarkovModelValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return

        if (modals.length) {
            if (isMounted) dispatch(closeModal())
            return
        }

        const path = model.id
            ? `${markovModelsRoute}/${VIEW}/${model.id}`
            : markovModelsRoute

        forceRerenderContent(path, dispatch)
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newModelData: MarkovModelCreate = {
            accountId: model.accountId || userData.accountId,
            name,
            description,
            creator: model.id ? model.creator : userData.userId,
        }

        SaveMarkovModel(
            model.id,
            newModelData,
            lang,
        ).then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)

                if (res.newModelId) replaceHistoryState(`${markovModelsRoute}/${EDIT}/${res.newModelId}`)
            }
            if (res.validation) return

            dispatch(setMarkovModelEdit({
                id: res.newModelId || model.id,
                ...newModelData,
            }))

            dispatch(setMarkovModelReloadList(false))
            dispatch(setMarkovModelReloadView(false))
            setTimeout(() => {
                dispatch(setMarkovModelReloadList(true))
                dispatch(setMarkovModelReloadView(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setMarkovModelReloadEdit(false))
                setTimeout(() => {
                    dispatch(setMarkovModelReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                </Col>

                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
